const defaultState = {
  loader: false,
  data: {}
};

import axios from 'axios';

export default {
  namespaced: true,
  name: 'productsStatistic',
  state() {
    return defaultState;
  },
  actions: {
    updateProductStatistic({ dispatch }, widget_info) {
      dispatch('getProductStatistic', widget_info);
    },
    dynamicUpdateProducts({ state, dispatch }) {
      dispatch('getProductStatistic', state.board_id);
    },
    getProductStatistic({ state, commit }, board_id) {
      if (!board_id) { return; }
      if (state.loader) { return; }
      commit('setLoader', true);
      let url = `${process.env.VUE_APP_URL}/sync/sales_stats/products?board_id=${board_id}`;
      axios({ url, method: 'GET' }).then((res) => {
        commit('update', { data: res.data.statistic, board_id });
        setTimeout(() => {
          commit('setLoader', false);
        }, 100);
      }, (err) => {
        console.warn(err);
        setTimeout(() => {
          commit('setLoader', false);
        }, 100);
      });
    }
  },
  mutations: {
    setLoader(state, value) {
      state.loader = value;
    },
    update(state, { board_id, data }) {
      state.data = data;
      state.board_id = board_id;
    },
  }
};
